import { initializeApp } from 'firebase/app';

import { APP_CONFIG } from '@/constants/appConfig';

const firebaseApp = initializeApp(APP_CONFIG.firebaseOptions);

export { firebaseApp };
